import { SECTION_AREA_TOP, SECTION_STACK } from './geometry';
import { cn } from '../ui/primitives';

/**
 * What the section area looks like before its data arrives.
 *
 * It stands in for the shape that is ABOUT to render, so the page doesn't
 * reshape itself the moment the quote lands — a skeleton of the wrong shape is a
 * worse loading state than no skeleton at all.
 *
 * It lives beside the layout, drawn to the same `geometry` constants, because
 * the alternative is what it replaced: a copy in the app restating the
 * measurements in its own words, silently drifting the first time they changed.
 *
 * Deliberately only the section area, matching `QuoteSections` — the page's own
 * title and stat-strip placeholders belong to the page, which is the thing that
 * knows how tall its header is.
 */
export function QuoteSectionsSkeleton({ className }: { className?: string }) {
	return (
		<div className={cn(SECTION_AREA_TOP, className)}>
			{/* The strip: a tab row and the rule under it. */}
			<div className="mb-8 h-8 animate-pulse rounded bg-surface-fill" />
			<div className={SECTION_STACK}>
				<div className="h-32 animate-pulse rounded-[var(--r-3)] bg-surface-fill" />
				<div className="h-64 animate-pulse rounded-[var(--r-3)] bg-surface-fill" />
			</div>
		</div>
	);
}
